import React from 'react';
import { LucideIcon, BookOpen, Users, Search, Inbox, FileX } from 'lucide-react';
import { Button } from './Button';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  variant?: 'default' | 'books' | 'users' | 'search' | 'deleted';
}

const variantConfig = {
  default: { icon: Inbox, color: 'text-slate-400', bg: 'bg-slate-100' },
  books: { icon: BookOpen, color: 'text-primary-500', bg: 'bg-primary-100' },
  users: { icon: Users, color: 'text-primary-500', bg: 'bg-primary-100' },
  search: { icon: Search, color: 'text-primary-500', bg: 'bg-primary-100' },
  deleted: { icon: FileX, color: 'text-red-400', bg: 'bg-red-100' },
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  variant = 'default',
}) => {
  const config = variantConfig[variant];
  const Icon = icon || config.icon;

  return (
    <div className="flex flex-col items-center justify-center py-12 sm:py-16 px-4 text-center animate-fade-in">
      <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-full ${config.bg} flex items-center justify-center mb-4 sm:mb-6`}>
        <Icon size={32} className={`sm:w-10 sm:h-10 ${config.color}`} />
      </div>
      <h3 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">{title}</h3>
      {description && (
        <p className="text-sm sm:text-base text-slate-500 max-w-md mb-6">{description}</p>
      )}
      {action && (
        <Button onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
};
